import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const ButtonsWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  padding-bottom: ${ds.get('metrics.xl')};
  padding-left: ${ds.get('metrics.s')};
  padding-right: ${ds.get('metrics.s')};
  
  ${media.desktop`
    padding-bottom: ${ds.get('metrics.xxl')};
  `}
`;

export default ButtonsWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HeroImage/TextBlock/ButtonsWrapper.jsx